import Vue from 'vue'

import VueWebPush from './plugin'

Vue.use(VueWebPush, {
	key: window.appConfigs.VAPID_KEY,
	file: '/worker.js',
	scope: '/',
})
